import { render, staticRenderFns } from "./Model3D.vue?vue&type=template&id=bacf8f72&scoped=true"
import script from "./Model3D.vue?vue&type=script&lang=js"
export * from "./Model3D.vue?vue&type=script&lang=js"
import style0 from "./Model3D.vue?vue&type=style&index=0&id=bacf8f72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf8f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacf8f72')) {
      api.createRecord('bacf8f72', component.options)
    } else {
      api.reload('bacf8f72', component.options)
    }
    module.hot.accept("./Model3D.vue?vue&type=template&id=bacf8f72&scoped=true", function () {
      api.rerender('bacf8f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/3d/Model3D.vue"
export default component.exports